import { Dialog } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const DialogStyled = styled(Dialog)(() => ({
  '.MuiDialog-paper': {
    width: '100%',
    maxWidth: 1144,
    padding: 32,
  },
}));
